import Funnel from "../services/funnel-service.js";
import Utils from "../services/utils-service.js";
import Mixin from "../mixin.js";
import FormInputs from "../services/inputs-service.js";

const template = `
<div id="binda_ads" v-if="input.ads" class="grid" v-show="fs.display(input)">
    <div :id="ad.ad_id" class="quote-select s12 clm center" v-for="(ad, idx) in input.ads" >
       <div class="card grid">
            <div class="s12 m12 l3 clm flex-center">
                <img class="center" :src="ad.medium_image_url" />
            </div>
            <div class="s12 m12 l6 clm center ">
                <h4>{{ad.headline}}</h4>
                <small>
                    <a tabindex="0" :href="'https://'+ad.display_url">{{ad.display_url}}</a>
                </small>
                <div class="grid collapse" >
                    <div class="accordion s12 clm" >
                        <ul class=" table coverage-table">
                            <li class="tr"  v-for="(desc,i) in ad.description" >
                                <div class="td text-left" ><span><small>{{ desc }}</small></span></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="s12 m12 l3 clm flex-center">
                <button class="button medium secondary-action fill secondary-btn next-step" @click.prevent="setAd(ad);exec($event, input)">
                    View My Quote
                    <img class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/arrow.svg">
                </button>
            </div>
        </div>
    </div>
</div>
`;

export default {
    name: 'b-ads',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    mounted: function () {
        // John M: deprecated - now SS
        /* this.$nextTick(function () {
            this.loadAdUnit();
        }); */
    },
    computed: {
        ...Vuex.mapGetters([
            'funnel'
        ]),
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        }
    },
    methods: {
        setAd: function(ad) {
            const muid = this.input.fxn.args.modelUid;
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: muid, key: 'modal_data', val: ad });
        },
        /* exec: function (e, input) {
            const fi = new FormInputs({ ctx: this.$store, router: this.$router });

            console.log(e,input);
            
            fi.eventHandler(e, input);
        } */
        // John M: deprecated - now SS
        /* loadAdUnit() {
            var s = document.createElement('script');
            s.type = 'text/javascript';

            try {
                const mAEx = JSON.stringify(this.input.mediaAlphaExchange);
                console.log('mAEx obj:', mAEx);
                const adScript = `
                    var MediaAlphaExchange = ${mAEx};
                    MediaAlphaExchange__load('binda_ads');
                `;
                s.appendChild(document.createTextNode(adScript));

                const parentDiv = document.getElementById("binda_ads").parentNode;
                const bAds = document.getElementById('binda_ads');
                parentDiv.insertBefore(s, bAds);
            } catch (e) {
                console.log('we have an error', e);
            }
        } */
    }
};
